<template>
    <div class="text-center has-padding-top">
        <ul class="pagination">
            <li><a href="#" @click.prevent="onPageChange(current - 1)">&lsaquo;</a></li>
            <li v-for="n in pagesCount" :class="{ 'active': current == n }" @click.prevent="onPageChange(n)"><a href="#">{{n}}</a></li>
            <li><a href="#" @click.prevent="onPageChange(current + 1)">&rsaquo;</a></li>
        </ul>
    </div>
</template>

<script>

    export default {
        name: 'pagination',
        props: ['pagesCount', 'current', 'onPageChange'],
        methods: {

        }

    }
</script>

<style scoped>
    .has-padding-top {
        padding-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// Pagination.vue?dd21e9d6